module.exports = __webpack_public_path__ + "img/ASFT_visualisoinnit_muokatut-09.aafa7e44.png";